export { default as ListEntidades } from './ListEntidades';